module.exports = __webpack_public_path__ + "assets/img/shopify.9176876a.png";